/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import DocsLayout from '../../components/DocsLayout';
import NextPage from '../../components/NextPage';
const MDXLayout = function ({children}) {
  return _jsx(DocsLayout, {
    title: "Advanced Usage",
    description: "Theming, refs, Security, Existing CSS, Tagged Template Literals, Server-Side Rendering and Style Objects",
    children: children
  });
};
import Theming from '../../sections/advanced/theming.mdx';
import Refs from '../../sections/advanced/refs.mdx';
import Security from '../../sections/advanced/security.mdx';
import ExistingCSS from '../../sections/advanced/existing-css.mdx';
import TaggedTemplateLiterals from '../../sections/advanced/tagged-template-literals.mdx';
import ServerSideRendering from '../../sections/advanced/server-side-rendering.mdx';
import ComponentsAsSelectors from '../../sections/advanced/components-as-selectors.mdx';
import StyleObjects from '../../sections/advanced/style-objects.mdx';
function _createMdxContent(props) {
  return _jsxs(_Fragment, {
    children: [_jsx(Theming, {}), "\n", _jsx(Refs, {}), "\n", _jsx(Security, {}), "\n", _jsx(ExistingCSS, {}), "\n", _jsx(TaggedTemplateLiterals, {}), "\n", _jsx(ServerSideRendering, {}), "\n", _jsx(ComponentsAsSelectors, {}), "\n", _jsx(StyleObjects, {}), "\n", _jsx(NextPage, {
      href: "/docs/api",
      title: "API Reference"
    })]
  });
}
function MDXContent(props = {}) {
  return _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  }));
}
export default MDXContent;
